import React, { useState, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/pro-regular-svg-icons/faTimes'
import { faColumns } from '@fortawesome/pro-regular-svg-icons/faColumns'

import * as S from './styled'

const ColumnSelector = ({ columns, selectedColumns, onSelectColumn }) => {
    const [isOpen, setIsOpen] = useState(false)
    const [columnOptions, setColumnOptions] = useState([])
    const path = window.location.pathname
    const claims = window.localStorage.getItem('claims')
    const user = claims ? JSON.parse(claims)['id'] : ''

    useEffect(() => {
        let storedColumns = window.localStorage.getItem(`${user}_columns${path}`)
        if (storedColumns) {
            storedColumns = JSON.parse(storedColumns)
            onSelectColumn(storedColumns)
        }
    }, [])

    useEffect(() => {
        const availableColumns = columns
            .filter(col => col.selectable === true)
            .map(col => {
                let columnSelected =
                    Object.keys(selectedColumns).includes(col.accessor) &&
                    selectedColumns[col.accessor] === true

                return {
                    label: col.Header,
                    isSelected: columnSelected,
                    accessor: col.accessor,
                }
            })

        setColumnOptions(availableColumns)
    }, [columns])

    const handleChange = e => {
        const value = e.target.value
        const columns = {
            ...selectedColumns,
            [value]: !selectedColumns[value],
        }

        window.localStorage.setItem(`${user}_columns${path}`, JSON.stringify(columns))
        onSelectColumn(columns)
    }

    return (
        <div className="!flex !flex-col">
            {columnOptions.length > 0 && (
                <S.ColumnSelector>
                    <S.ColumnSelectorButton
                        className="btn btn-sm btn-outline-secondary"
                        type="button"
                        onClick={() => setIsOpen(!isOpen)}
                        data-testid="manage-columns-toggle"
                    >
                        {isOpen ? (
                            <>
                                <FontAwesomeIcon icon={faTimes} className="!mr-2" />
                                Close
                            </>
                        ) : (
                            <>
                                <FontAwesomeIcon icon={faColumns} className="!mr-2" />
                                Manage Columns
                            </>
                        )}
                    </S.ColumnSelectorButton>

                    {isOpen && (
                        <S.ColumnSelectorList>
                            {columnOptions.map((option, i) => (
                                <S.ColumnSelectorOption key={i}>
                                    <label>
                                        <input
                                            type="checkbox"
                                            className="!mr-2"
                                            checked={option.isSelected}
                                            value={option.accessor}
                                            onChange={handleChange}
                                            data-testid={`checkbox-${option.label
                                                .toString()
                                                .toLowerCase()
                                                .replaceAll(' ', '-')}`}
                                        />
                                        {option.label}
                                    </label>
                                </S.ColumnSelectorOption>
                            ))}
                        </S.ColumnSelectorList>
                    )}
                </S.ColumnSelector>
            )}
        </div>
    )
}

export default ColumnSelector
